import { PerformanceTeamPersonalReview } from 'app/library/performance-personal-review/models/performance-team-personal-review.model';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { PerformanceProfilePersonalReview } from '../models/performance-profile-personal-review.model';

export class SetPerformanceProfilePersonalReview {
    static readonly type = '[PerformanceProfilePersonalReview] SetPerformanceProfilePersonalReview';

    constructor(public payload: PerformanceProfilePersonalReview) {}
}

export class UnsetPerformanceProfilePersonalReview {
    static readonly type = '[PerformanceProfilePersonalReview] UnsetPerformanceProfilePersonalReview';
}

export class UpdatePerformanceProfilePersonalReview {
    static readonly type = '[PerformanceProfilePersonalReview] UpdatePerformanceProfilePersonalReview';

    constructor(public payload: { review: PerformanceProfilePersonalReview | PerformanceTeamPersonalReview; teamReviewId: string }) {}
}

export class UpdatePerformanceProfilePersonalReviewSuccess {
    static readonly type = '[PerformanceProfilePersonalReview] UpdatePerformanceProfilePersonalReviewSuccess';

    constructor(public payload: PerformanceProfilePersonalReview) {}
}

export class UpdatePerformanceProfilePersonalReviewFailure {
    static readonly type = '[PerformanceProfilePersonalReview] UpdatePerformanceProfilePersonalReviewFailure';

    constructor() {}
}

export class FetchPerformanceProfilePersonalReview {
    static readonly type = '[PerformanceProfilePersonalReview] FetchPerformanceProfilePersonalReview';

    constructor(public payload: string) {}
}

export class FetchPerformanceProfilePersonalReviewSuccess {
    static readonly type = '[PerformanceProfilePersonalReview] FetchPerformanceProfilePersonalReviewSuccess';

    constructor(public payload: PerformanceProfilePersonalReview) {}
}

export class FetchPerformanceProfilePersonalReviewFailure {
    static readonly type = '[PerformanceProfilePersonalReview] FetchPerformanceProfilePersonalReviewFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class SetPerformanceProfilePersonalReviews {
    static readonly type = '[PerformanceProfilePersonalReview] SetPerformanceProfilePersonalReviews';

    constructor(public payload: PerformanceProfilePersonalReview[]) {}
}

export class FetchPerformanceProfilePersonalReviews {
    static readonly type = '[PerformanceProfilePersonalReview] FetchPerformanceProfilePersonalReviews';

    constructor(
        public payload: {
            userId: string;
            pageSize?: number;
            pageNumber?: number;
            typeId?: string;
        }
    ) {}
}

export class FetchPerformanceProfilePersonalReviewsSuccess {
    static readonly type = '[PerformanceProfilePersonalReview] FetchPerformanceProfilePersonalReviewsSuccess';
}

export class FetchPerformanceProfilePersonalReviewsFailure {
    static readonly type = '[PerformanceProfilePersonalReview] FetchPerformanceProfilePersonalReviewsFailure';
}

export class SearchPerformanceProfilePersonalReviews {
    static readonly type = '[PerformanceProfilePersonalReview] SearchPerformanceProfilePersonalReviews';

    constructor(public payload: string) {}
}
